import { takeLatest } from 'redux-saga/effects';
import { PlansSaga } from './Saga';
import * as ActionTypes from './ActionTypes';

export default function* PlansWatcher() {
    yield takeLatest(ActionTypes.PLANS_GET_REQUEST, PlansSaga);
}

